// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';

// Misc / utils
import IconCarat from 'images/icons/arrow-grey.svg';
import * as S from './styles';

const Button = React.forwardRef(
  (
    {
      ariaLabel,
      ariaDescribedBy,
      ariaExpanded,
      ariaLabeledBy,
      buttonType,
      className,
      disabled = false,
      ariaDisabled = false,
      active = false,
      icon,
      iconWidth = '12px',
      iconHeight = '12px',
      iconAriaAltText = '',
      onClick,
      onKeyDown,
      children,
      showCarat,
      flex,
      justifyContent,
      alignItems,
      ...rest
    },
    ref,
  ) => (
    <S.Button
      onClick={onClick}
      ref={ref}
      aria-describedby={ariaDescribedBy}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabeledBy}
      aria-expanded={ariaExpanded}
      buttonType={buttonType}
      className={className}
      disabled={disabled}
      onKeyDown={onKeyDown}
      aria-disabled={ariaDisabled}
      active={active}
      {...rest}
    >
      {flex ? (
        <S.FlexContainer justifyContent={justifyContent} alignItems={alignItems}>
          {icon && <S.Icon src={icon} width={iconWidth} height={iconHeight} loading="lazy" alt={iconAriaAltText} />}
          {children}
          {showCarat && (
            <S.CaratSpan aria-hidden="true">
              <S.Carat
                src={IconCarat}
                width="12px"
                height="12px"
                alt=""
                isActive={ariaExpanded}
                fetchpriority="low"
                decoding="async"
              />
            </S.CaratSpan>
          )}
        </S.FlexContainer>
      ) : (
        <>
          {icon && <S.Icon src={icon} width={iconWidth} height={iconHeight} loading="lazy" alt={iconAriaAltText} />}
          {children}
          {showCarat && (
            <S.CaratSpan aria-hidden="true">
              <S.Carat
                src={IconCarat}
                width="12px"
                height="12px"
                alt=""
                isActive={ariaExpanded}
                fetchpriority="low"
                decoding="async"
              />
            </S.CaratSpan>
          )}
        </>
      )}
    </S.Button>
  ),
);

export default Button;
